// Modules
import React, { useEffect, useState } from 'react'

// Components
import { TemplateContainerFullWidth, TemplateContainerFullWidthBlue, PhonesHelpCenter } from 'components'
import { Content } from './styles'
import { defaultConfig } from 'modules/RemoteConfig/defaultConfig'
import { goToPage } from 'redesign/utils/goToPage'

import Unico from 'assets/unico.svg'
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'
import { useTracking } from 'react-tracking'
import { useBiometry } from 'hooks/useBiometry'

interface Props {
    nextUrl?: string
}

export const ConfirmContact: React.FC<Props> = ({ nextUrl }) => {
    const { isFeatureEnabled } = useRemoteConfig()
    const { trackEvent } = useTracking()
    const IS_UNICO_ENABLED = isFeatureEnabled('AUTH_ENABLE_UNICO')
    const { createBiometry } = useBiometry([])
    const [isLoading, setIsLoading] = useState(false)

    const goToUpdateContacts = async () => {
        setIsLoading(true)
        await createBiometry()
    }

    const handleNext = () => {
        IS_UNICO_ENABLED ? goToUpdateContacts() : goToPage(nextUrl || defaultConfig.strings.AUTH_REDIRECT_LOGIN)
    }

    useEffect(() => {
        if (IS_UNICO_ENABLED) {
            trackEvent({
                event: 'funnel_step',
                funnel: {
                    name: 'Reset de Senha',
                    current_step: 'Confirmação identidade sem contato no MDM',
                    origin: 'Login faseado',
                },
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return IS_UNICO_ENABLED ? (
        <TemplateContainerFullWidthBlue
            buttonText="Confirmar identidade agora"
            goTo={handleNext}
            image={Unico}
            imageAlt="Ilustração de reconhecimento facial"
            isLoading={isLoading}
            title="Preciso confirmar sua identidade"
        >
            <Content>
                <p>Pra isso, é só informar um número de contato válido.</p>
            </Content>
        </TemplateContainerFullWidthBlue>
    ) : (
        <TemplateContainerFullWidth
            buttonText="Voltar para o início"
            goTo={handleNext}
            image={''}
            imageAlt=""
            title="Confirme seus contatos"
            titleType="medium"
        >
            <Content>
                <p>
                    Você ainda não tem número de celular ou e-mail cadastrado, e isto é essencial para criar sua conta no Nav Dasa.
                    Para continuar, entre em contato com o time de atendimento e informe um contato válido pelo WhatsApp:
                </p>
                <PhonesHelpCenter />
            </Content>
        </TemplateContainerFullWidth>
    )
}
